import { useQuery } from 'react-query';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { getAnnotation } from '@api/annotations';
import { annotationsFeatureSelector } from '@store/common/selectors';
import { formatAnnotationRow } from './utils';

function useFetchAnnotation({ id }) {
  const isAnnotationsEnabled = useSelector(annotationsFeatureSelector);

  // stale time prevents redundant calls from multiple subscribers
  // mutations will force a refetch
  // using name as `annotations` itself for easy invalidation
  const { data = null, dataUpdatedAt } = useQuery(
    ['annotations', id],
    () => {
      return getAnnotation({ params: { id } });
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      enabled: !!id && isAnnotationsEnabled,
      staleTime: 2 * 60 * 1000, // 2m
      // notifyOnChangeProps: 'tracked',
      placeholderData: { data: null },
      select: (response) => {
        const record = get(response, 'data.annotation', null);
        if (record) {
          const formattedRow: any = formatAnnotationRow(record);
          return formattedRow;
        }
        return null;
      },
      onError: (err) => {
        console.error('annotation error', err);
      },
    },
  );

  return { data, dataUpdatedAt };
}

export default useFetchAnnotation;
